import { render, staticRenderFns } from "./TenderReports.vue?vue&type=template&id=22be5f3b&scoped=true&"
import script from "./TenderReports.vue?vue&type=script&lang=js&"
export * from "./TenderReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22be5f3b",
  null
  
)

export default component.exports